import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ME } from "../actions/actionTypes";
import { getAuthToken } from "../helpers/storage";

//pobieramy token ze storage i inicjalizujemy stan domyslny
let flow24token = getAuthToken();
const initialState = flow24token
  ? { authenticated: true, flow24token, authenticatedUser: null }
  : { authenticated: false, authenticatedUser: null };

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case AUTH_LOGIN: {
      return {
        ...state,
        authenticated: true,
        flow24token: action.payload
      };
    }
    case AUTH_LOGOUT: {
      return {
        ...state,
        authenticated: false,
        authenticatedUser: null,
        flow24token: null
      };
    }
    case AUTH_ME: {
      return {
        ...state,
        authenticatedUser: action.payload
      };
    }
    default:
      return state;
  }
}
